import styled from 'styled-components'

const ModalInner = styled.div`
  height: 100%;
  padding: 0 20px 0;
  position: relative;
`

export default ModalInner
